import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchAssociationQueueAssociations(id) {
    return useQuery(['associationQueue', id, 'associations'], () => PESService.getAssociations(id), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchAssociationQueueAssociations;
